export default "__VITE_ASSET__DEx4cCnw__"